export const environmentsWithDatadog = [
  'production',
  'local',
  'development',
  'stage',
  'dev',
];

export const getEnvironmentName = (): string => {
  let name = import.meta.env.MODE;
  if (window?.location?.hostname === 'prontohousing.io') {
    name = 'production';
  }
  if (window?.location?.hostname === 'stage.prontohousing.io') {
    name = 'stage';
  }
  if (window?.location?.hostname === 'dev.prontohousing.io') {
    name = 'dev';
  }

  // Default to 'local' if no specific environment is detected
  if (!name || name === 'development') {
    name = 'local';
  }

  return name;
};
